import axios from "axios";

// Resolve the API base URL.
// The backend is always served under `/api` on the SAME host as the frontend
// (via the platform ingress), in both preview and production. We therefore
// prefer the current page origin (same-origin) to avoid any cross-origin/CORS
// or redirect issue — notably when the canonical apex (swiss-pagan.ch) is served
// while the build-time REACT_APP_BACKEND_URL points at the www host.
// REACT_APP_BACKEND_URL stays the source of truth / fallback (used at build time
// and when a page origin is unavailable, e.g. SSR/tests).
const CONFIGURED_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

function resolveBackendUrl() {
  try {
    if (typeof window !== "undefined" && window.location && window.location.origin) {
      if (!CONFIGURED_BACKEND_URL) return window.location.origin;
      const configuredHost = new URL(CONFIGURED_BACKEND_URL).host;
      // Same host (preview): keep configured value. Different host (prod apex vs
      // configured www): use same-origin so API calls hit the page's own host.
      return configuredHost === window.location.host ? CONFIGURED_BACKEND_URL : window.location.origin;
    }
  } catch (e) {
    /* fall through to configured */
  }
  return CONFIGURED_BACKEND_URL;
}

export const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;
